'use strict';

export const UploadStatus = {
  PENDING: 0,
  UPLOADING: 1,
  UPLOADED: 2,
};

// Legacy support
export const PENDING = UploadStatus.PENDING;
export const UPLOADING = UploadStatus.UPLOADING;
export const UPLOADED = UploadStatus.UPLOADED;



// WEBPACK FOOTER //
// ./src/js/core-utilities/upload-service/UPLOAD_STATUS.js